import { defineComponent as _defineComponent } from 'vue'
import { Chart } from 'highcharts-vue'
import { FarmFireRiskChartOptionsFactory } from '../factories/FarmFireRiskChartOptions.factory'
import { RecentFireRisk } from '@/@core/fire-risk-dashboard/domain/entities/RecentFireRisk'


export default /*#__PURE__*/_defineComponent({
  __name: 'FarmFireRiskChart',
  props: {
    farm: null
  },
  setup(__props: any) {



return { __sfc: true,Chart, FarmFireRiskChartOptionsFactory }
}

})